"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../atome");
const Calendar_style_1 = require("./Calendar.style");
const User_service_1 = __importDefault(require("../../../services/User.service"));
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
function Calendar({ slots = [], onChange, mainDoctor, navigation, selectedDate, }) {
    const [calendarMonth, setCalendarMonth] = (0, react_1.useState)(new Date().getMonth());
    const [calendarYear, setCalendarYear] = (0, react_1.useState)(new Date().getFullYear());
    const [displayDays, setDisplayDays] = (0, react_1.useState)([]);
    const [doctorAbsence, setDoctorAbsence] = (0, react_1.useState)({});
    const dispatch = (0, hooks_1.useAppDispatch)();
    const calculateRecentAbsence = (absences) => {
        const recentAbsence = absences[0]; // they are sent in ascending order from backend
        const recentAbsenceStartDate = new Date(recentAbsence.startDate);
        recentAbsenceStartDate.setHours(0, 0, 0, 0);
        const recentAbsenceEndDate = new Date(recentAbsence.endDate);
        recentAbsenceEndDate.setHours(0, 0, 0, 0);
        const finalAbsence = { startDate: '', endDate: '' };
        finalAbsence.startDate =
            recentAbsenceStartDate.getDate() +
                '.' +
                (recentAbsenceStartDate.getMonth() + 1) +
                '.' +
                recentAbsenceStartDate.getFullYear();
        finalAbsence.endDate =
            recentAbsenceEndDate.getDate() +
                '.' +
                (recentAbsenceEndDate.getMonth() + 1) +
                '.' +
                recentAbsenceEndDate.getFullYear();
        setDoctorAbsence(finalAbsence);
    };
    (0, react_1.useEffect)(() => {
        User_service_1.default.getDoctorAbsenceCurrentMonth(mainDoctor)
            .then(res => {
            if (res.error) {
                if (res.message.response.status === 401) {
                    dispatch((0, reducers_1.setAuth)({ isAuthenticated: false }));
                    navigation.navigate('Login');
                }
                console.log(res.message);
            }
            calculateRecentAbsence(res.data);
        })
            .catch(err => {
            console.log(err.message);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        setFirstDateWithSlots();
    }, [slots]);
    (0, react_1.useEffect)(() => {
        changeDays();
        if (selectedDate) {
            setCalendarMonth(selectedDate.getMonth());
        }
    }, [selectedDate]);
    const changeMonth = (month) => {
        if (month === -1) {
            setCalendarYear(calendarYear - 1);
            setCalendarMonth(11);
            return;
        }
        if (month === 12) {
            setCalendarYear(calendarYear + 1);
            setCalendarMonth(0);
            return;
        }
        setCalendarMonth(month);
    };
    const setFirstDateWithSlots = () => {
        const minDate = new Date(Math.min(...slots.map(slot => new Date(slot.start).getTime())));
        setCalendarYear(minDate.getFullYear());
        setCalendarMonth(minDate.getMonth());
        const parsedMindate = new Date(minDate.setHours(0, 0, 0, 0));
        // @ts-ignore
        selectedDate < parsedMindate && onChange(parsedMindate);
    };
    const changeDays = () => {
        const firstDay = new Date(calendarYear, calendarMonth, 1);
        const lastDay = new Date(calendarYear, calendarMonth + 1, 0).getDate();
        const actualDay = new Date(new Date().setHours(0, 0, 0, 0));
        const days = [];
        let daysRow = [];
        if (firstDay.getDay() === 0) {
            for (let i = 0; i < 6; i++) {
                daysRow.push(react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.dayContainer], key: `empty-container-${i}` },
                    react_1.default.createElement(atome_1.Text, { style: [Calendar_style_1.styles.day], key: `empty-${i}` }, ' ')));
            }
        }
        if (firstDay.getDay() > 1) {
            for (let i = 0; i < firstDay.getDay() - 1; i++) {
                daysRow.push(react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.dayContainer], key: `empty-container-${i}` },
                    react_1.default.createElement(atome_1.Text, { style: [Calendar_style_1.styles.day], key: `empty-${i}` }, ' ')));
            }
        }
        for (let i = 0; i < lastDay; i += 1) {
            const calendarDay = new Date(calendarYear, calendarMonth, i + 1);
            const isDatePassed = calendarDay < actualDay;
            const hasSlot = slots?.find(slot => {
                const slotDate = new Date(slot.start);
                return (slotDate.getFullYear() === calendarDay.getFullYear() &&
                    slotDate.getMonth() === calendarDay.getMonth() &&
                    slotDate.getDate() === calendarDay.getDate());
            });
            const isDoctorAbsent = slots?.find(slot => {
                const slotDate = new Date(slot.start);
                return (slot?.isDoctorAbsent &&
                    slotDate.getFullYear() === calendarDay.getFullYear() &&
                    slotDate.getMonth() === calendarDay.getMonth() &&
                    slotDate.getDate() === calendarDay.getDate());
            });
            daysRow.push(react_1.default.createElement(atome_1.CalendarDay, { isDatePassed: isDatePassed, hasSlot: !!hasSlot, selectedDate: selectedDate, calendarDate: calendarDay, isSelected: selectedDate.getTime() === calendarDay.getTime(), 
                // @ts-ignore
                onPress: () => onChange(calendarDay), isDoctorAbsent: !!isDoctorAbsent, key: i }, i + 1));
            if (daysRow.length === 7 || i === lastDay - 1) {
                if (daysRow.length < 7) {
                    for (let j = daysRow.length; j < 7; j += 1) {
                        daysRow.push(react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.dayContainer], key: `empty-last-container-${i + j}` },
                            react_1.default.createElement(atome_1.Text, { style: [Calendar_style_1.styles.day], key: `empty-last-${i + j}` }, ' ')));
                    }
                }
                days.push(react_1.default.createElement(react_native_1.View, { key: `row-${i}`, style: [Calendar_style_1.styles.daysRow] }, daysRow));
                daysRow = [];
            }
        }
        setDisplayDays(days);
    };
    (0, react_1.useEffect)(() => {
        changeDays();
    }, [calendarMonth, calendarYear]);
    const monthNames = [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
    ];
    return (react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.calendar] },
        doctorAbsence && Object.entries(doctorAbsence).length !== 0 && (react_1.default.createElement(react_native_1.View, { style: [{ marginHorizontal: 30 }] },
            react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.row] },
                react_1.default.createElement(atome_1.Icon, { icon: "attention" }),
                react_1.default.createElement(atome_1.Label, { style: [Calendar_style_1.styles.absenceTitle] }, "Bitte beachten Sie:")),
            react_1.default.createElement(atome_1.Text, { style: [Calendar_style_1.styles.absenceDescription] },
                "Ihr behandelnder Arzt ist in der Zeit vom ",
                doctorAbsence.startDate,
                ' ',
                "bis ",
                doctorAbsence.endDate,
                " abwesend. Neu gebuchte Termine werden in diesem Zeitraum vertreten."))),
        react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.row, Calendar_style_1.styles.alignCenter] },
            react_1.default.createElement(react_native_1.Pressable, { onPress: () => changeMonth(calendarMonth - 1), style: [Calendar_style_1.styles.changeMonthButton, Calendar_style_1.styles.changeMonthButtonDecrease] },
                react_1.default.createElement(atome_1.Icon, { icon: 'chevron' })),
            react_1.default.createElement(atome_1.Text, { style: [Calendar_style_1.styles.monthText] },
                monthNames[calendarMonth],
                " ",
                calendarYear),
            react_1.default.createElement(react_native_1.Pressable, { onPress: () => changeMonth(calendarMonth + 1), style: [Calendar_style_1.styles.changeMonthButton, Calendar_style_1.styles.changeMonthButtonIncrease] },
                react_1.default.createElement(atome_1.Icon, { icon: 'chevron' }))),
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.daysRow] },
                react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.dayContainer] },
                    react_1.default.createElement(atome_1.Text, { style: [Calendar_style_1.styles.day] }, "Mo")),
                react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.dayContainer] },
                    react_1.default.createElement(atome_1.Text, { style: [Calendar_style_1.styles.day] }, "Di")),
                react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.dayContainer] },
                    react_1.default.createElement(atome_1.Text, { style: [Calendar_style_1.styles.day] }, "Mi")),
                react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.dayContainer] },
                    react_1.default.createElement(atome_1.Text, { style: [Calendar_style_1.styles.day] }, "Do")),
                react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.dayContainer] },
                    react_1.default.createElement(atome_1.Text, { style: [Calendar_style_1.styles.day] }, "Fr")),
                react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.dayContainer] },
                    react_1.default.createElement(atome_1.Text, { style: [Calendar_style_1.styles.day] }, "Sa")),
                react_1.default.createElement(react_native_1.View, { style: [Calendar_style_1.styles.dayContainer] },
                    react_1.default.createElement(atome_1.Text, { style: [Calendar_style_1.styles.day] }, "So"))),
            react_1.default.createElement(react_native_1.View, null, displayDays))));
}
exports.Calendar = Calendar;
